export default __webpack_public_path__ + "static/media/zalooa.6462d2bb.png";